import { render, staticRenderFns } from "./DateTimeRangeConfig.vue?vue&type=template&id=0be73fb4&scoped=true"
import script from "./DateTimeRangeConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeRangeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be73fb4",
  null
  
)

export default component.exports